import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ROUTES } from '../../config/constants';
import './TabNavigation.css';

const TabNavigation = ({ tabs = [] }) => {
  const location = useLocation();

  const defaultTabs = [
    { label: 'Experiences', path: ROUTES.RESUME },
    { label: 'Education', path: ROUTES.EDUCATION },
    { label: 'Volunteering', path: ROUTES.VOLUNTEERING },
  ];

  const tabsToRender = tabs.length > 0 ? tabs : defaultTabs;

  return (
    <nav className="tab-navigation" aria-label="Section navigation">
      <ul className="nav nav-tabs" role="tablist">
        {tabsToRender.map((tab, index) => {
          const isActive = location.pathname === tab.path;
          return (
            <li key={tab.path || index} className="navitem">
              <Link
                className={`nav-link ${isActive ? 'active' : ''}`}
                to={tab.path}
                role="tab"
                aria-selected={isActive}
                aria-controls={tab.path.replace('/', '')}
              >
                {tab.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

TabNavigation.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

export default TabNavigation;

